import { UserType } from '@grammarly/http-clients-auth'
import { DesktopOsType, MobileOsType } from '../../services/facade'
import { Placement } from '../../../contexts/placement-context'

enum ProductGroup {
  Llama = 'Llama',
  BrowserExtension = 'BrowserExtension',
  Keyboard = 'Keyboard',
}

type LlamaEvent = `${DesktopOsType}${ProductGroup.Llama}DesktopDownload`
type KeyboardEvent = `${MobileOsType}${ProductGroup.Keyboard}MobileDownload`
type ExtensionInstalledEvent = 'extensionInstalled'
type AccountCreationEvent = 'accountCreation'

export type Template = 'all-pages'
export enum GA4Event {
  pageView = 'page_view',
  btnClick = 'btn_click',
  btnClickDownload = 'btn_click_download',
}

export const eventToTemplateName: { [e in GA4Event]: Template } = {
  [GA4Event.pageView]: 'all-pages',
  [GA4Event.btnClick]: 'all-pages',
  [GA4Event.btnClickDownload]: 'all-pages',
}

interface PageViewDataLayer {
  user_id: string | null
  user: {
    id: string | undefined
    email: string | undefined
    subscription: UserType
    role: string | undefined
    industry: string | undefined
    team: string | undefined
    companySize: string | undefined
    graduationYear: string | undefined
  }
}

interface BtnClickDataLayer {
  btn_location: Placement | undefined
  btn_name: string | undefined // Represents the description of the button, generally button text
  btn_action?: string
}

interface BtnClickDownloadDataLayer {
  btn_location: Placement | undefined
  product_name: LlamaProductName
  btn_name: string | undefined // Represents the description of the button, generally button text
}

// Union type for all events
export type GtmEvent = KeyboardEvent | LlamaEvent | ExtensionInstalledEvent | AccountCreationEvent | GA4Event

export enum LlamaProductName {
  LlamaMac = 'llamaMac',
  LlamaWindows = 'llamaWindows',
}

export type DataLayer = Partial<PageViewDataLayer | BtnClickDataLayer | BtnClickDownloadDataLayer>
